<template>
    <div class="h100 ml20">
        <div class="m-transsion-panel">
            <div class="m-transsion-apps">
                <div class="pd20">
                    <button class="m-primary-button" @click="dialogVisible=true">添加</button>
                </div>
                <div class="m-apps-list">
                    <div class="m-app" :class="curApp.id == item.id ? 'selected' : ''" v-for="item in apps" :key="item.id" @click="selectApp(item)">
                        <div class="flex items-center content-center bold fs20" style="width: 20px; text-shadow: 1px 1px 2px #000000bb;">
                            {{ item.prefix }}
                        </div>
                        <div class="ml10">
                            <div class="flex fs12 a90 bold">{{ item.name }}</div>
                            <div class="flex fs10">{{ item.package_name }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-width">
                <div class="pd20" v-if="curApp.id != null">
                    <div class="mb15 flex">
                        <div class="flex-1">
                            <div class="flex bold white fs16">{{ curStat.active_count }}</div>
                            <div class="flex fs13" style="color: #9ea4ad;">今日总激活数</div>
                        </div>
                        <div class="flex-1">
                            <div class="flex bold white fs16">{{ curStat.callback_count }}</div>
                            <div class="flex fs13" style="color: #9ea4ad;">今日当前回传数</div>
                        </div>
                    </div>
                    <el-progress color="#676cf6" text-color="#fff" :text-inside="true" :stroke-width="26" :percentage="curStat.progress"></el-progress>
                </div>
                <div class="pl20 pr20">
                    <el-table v-loading="loading" :data="historyData" style="width: 100%" size="mini">
                        <el-table-column prop="date" label="日期"></el-table-column>
                        <el-table-column prop="active_count" label="激活"></el-table-column>
                        <el-table-column prop="callback_count" label="回传数"></el-table-column>
                        <el-table-column prop="callback_rate" label="回传率"></el-table-column>
                    </el-table>

                    <el-pagination
                        layout="prev, pager, next"
                        :total="page.total"
                        :page-size="page.len"
                        :current-page="page.page"
                        @current-change="getCallbackHistory"
                        >
                    </el-pagination>
                </div>
            </div>

            <div class="m-transsion-config" v-if="curApp.id != null">
                <div class="pd20 flex-height">
                    <div class="flex fs12">回传率(%)</div>
                    <div class="mt5">
                        <el-input v-model="curApp.callback_rate" placeholder="请输入内容"></el-input>
                    </div>
    
                    <!-- <div class="flex fs12 mt15">出价</div>
                    <div class="mt5">
                        <el-input v-model="curApp.showPrice" placeholder="请输入内容"></el-input>
                    </div> -->

                    <div class="flex fs12 mt15">最低版本号</div>
                    <div class="mt5">
                        <el-input v-model="curApp.min_version" type="number" placeholder="请输入回传最低版本号"></el-input>
                    </div>
                </div>
                <div class="pd20">
                    <button class="m-primary-button" @click="saveCurApp">保存</button>
                </div>
            </div>
        </div>



        <el-dialog
            custom-class="my-dialog"
            :visible.sync="dialogVisible"
            :show-close="false"
            width="40%">
            <div style="height: 50px; background-color: #f4f4f6; color: #828392;padding: 0 20px 0 20px; display: flex; align-items: center; font-weight: bold; ">
                <span class="flex-width flex">添加回传APP</span>
                <i class="el-icon-close"></i>
            </div>
            <div class="pd20">
                <div class="flex">
                    包名
                </div>
                <div class="mt5">
                    <el-input v-model="addForm.package_name" placeholder="请输入内容"></el-input>
                </div>

                <button class="m-primary-button mt30" @click="saveAddApp">保存</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            addForm: {
                package_name: null
            },
            apps: [],
            curApp: {},
            curStat: {
                callback_count: 0,
                active_count: 0,
                progress: 0
            },
            historyData: [],
            loading: false,
            page: {
                count: 0,
                page: 1,
                len: 10
            }
        }
    },
    created() {
        this.getCallbackApps();
    },
    methods: {
        async getCallbackApps() {
            let rs = await this.$api.getCallbackApps()
            if (rs.err == 0) {
                for (let item of rs.data) {
                    item.prefix = item.name.substring(0, 1).toUpperCase();
                    if (item.cost) {
                        item.showCost = (item.cost / 1000).toFixed(3)
                    } else {
                        item.showCost = 0;
                    }
                    if (item.price) {
                        item.showPrice = (item.price / 1000).toFixed(3)
                    } else {
                        item.showPrice = 0;
                    }

                    item.callback_count = 0;
                    if (item.cost && item.price) {
                        item.callback_count = Math.floor(item.cost / item.price)
                    }
                }
                this.apps = rs.data;
            }
        },
        async saveAddApp() {
            if (this.addForm.package_name != null && this.addForm.package_name != "") {
                let rs = await this.$api.addCallbackApp(this.addForm.package_name);
                this.dialogVisible = false;
                if (rs.err == 0) {
                    this.$message({
                        type: "success",
                        message: "添加成功"
                    })
                    this.getCallbackApps();
                }
            }
        },
        async selectApp(item) {
            this.curApp = item;
            this.curStat.callback_count = 0;
            this.curStat.progress = 0;
            let date = new Date().Format("yyyy-MM-dd")
            let rs = await this.$api.getCallbackStat(item.id, date);
            if (rs.err == 0) {
                this.curStat = rs.data;
                if (this.curStat.active_count > 0) {
                    this.curStat.progress = (this.curStat.callback_count / this.curStat.active_count * 100).toFixed(2);
                }
            }

            this.getCallbackHistory();
        },
        async getCallbackHistory(page) {
            if (page) {
                this.page.page = page;
            }
            this.loading = true;
            let rs = await this.$api.getCallbackHistory(this.curApp.id, this.page.page - 1, this.page.len);
            if (rs.err == 0) {
                for (let item of rs.data) {
                    if (item.active_count > 0) {
                        item.callback_rate = (item.callback_count / item.active_count * 100).toFixed(2) + "%";
                    } else {
                        item.callback_rate = "0%"
                    }
                }
                this.historyData = rs.data;
                this.page.total = rs.count;
            }
            this.loading = false;
        },
        async saveCurApp() {
            let rs = await this.$api.saveCallbackApp(this.curApp);
            if (rs.err == 0) {
                // this.curApp.cost = Math.floor(this.curApp.showCost * 1000);
                // this.curApp.price = Math.floor(this.curApp.showPrice * 1000);
                this.$message({
                    type: "success",
                    message: "保存成功"
                })
            }
        }
    }
}
</script>


<style lang="less" scoped>
.m-transsion-panel {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
	border-radius: 10px;
	background-color: white;
    height: 100%;
    display: flex;

    .m-transsion-apps {
        height: 100%;
        width: 260px;
        display: flex;
        flex-direction: column;
        border-right: 1px solid #eaeaec;

        .m-apps-list {
            flex: 1;
            height: 0;
            overflow-y: auto;

            .m-app {
                display: flex;
                padding: 0 20px 0 20px;
                margin-bottom: 10px;
                border-left: 3px solid white;
                cursor: pointer;

                transition: color 0.2s linear;
                transition: border-left 0.2s linear;

                &.selected {
                    border-left: 3px solid #676cf6;
                    color: #676cf6;
                }
                
                &:last-child {
                    margin-bottom: 0px;
                }
            }
        }
    }

    .m-transsion-config {
        height: 100%;
        width: 260px;
        display: flex;
        flex-direction: column;
        border-left: 1px solid #eaeaec;
    }
}
</style>